import UserProfileCommentsSection from './UserProfileCommentsSection.vue';
import UserProfileFollowersSection from './UserProfileFollowersSection.vue';
import UserProfileFollowingSection from './UserProfileFollowingSection.vue';
import UserProfileProjectsSection from './UserProfileProjectsSection.vue';
import UserProfileOverviewSection from './UserProfileOverviewSection.vue';

const routes = [
    {
        path: '/overview',
        name: 'user-profile-overview',
        components: { profile: UserProfileOverviewSection },
    },
    {
        path: '/projects',
        name: 'user-profile-projects',
        components: { profile: UserProfileProjectsSection },
    },
    {
        path: '/followers',
        name: 'user-profile-followers',
        components: { profile: UserProfileFollowersSection },
    },
    {
        path: '/following',
        name: 'user-profile-following',
        components: { profile: UserProfileFollowingSection },
    },
    {
        path: '/comments',
        name: 'user-profile-comments',
        components: { profile: UserProfileCommentsSection },
    },
];

export {
    routes,
};
